// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"3212526b","153":"5342250e","500":"51adf0e3","638":"7bb85b13","724":"53ddecee","885":"1698e0ff"}[chunkId] + ".chunk.js";
};